// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`renders and matches snapshot 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthMd"
      >
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <div
            class="MuiSnackbar-root MuiSnackbar-anchorOriginTopCenter"
          >
            <div
              class="MuiPaper-root MuiAlert-root MuiAlert-filledError makeStyles-root-1 MuiPaper-elevation0"
              direction="down"
              role="alert"
              style="opacity: 1; transform: scale(1, 1); transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;"
            >
              <div
                class="MuiAlert-icon"
              >
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit"
                  focusable="false"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                  />
                </svg>
              </div>
              <div
                class="MuiAlert-message"
              />
              <div
                class="MuiAlert-action"
              >
                <button
                  aria-label="Close"
                  class="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit MuiIconButton-sizeSmall"
                  tabindex="0"
                  title="Close"
                  type="button"
                >
                  <span
                    class="MuiIconButton-label"
                  >
                    <svg
                      aria-hidden="true"
                      class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                      focusable="false"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                      />
                    </svg>
                  </span>
                  <span
                    class="MuiTouchRipple-root"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          
          <div
            class="MuiBox-root MuiBox-root-3"
          >
            <span
              class="MuiTypography-root MuiTypography-body1"
            >
              Business Cost Premium / Longitudinal Family Physician
            </span>
          </div>
          <label
            class="MuiFormControlLabel-root"
          >
            <span
              aria-disabled="false"
              class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-4 MuiCheckbox-root MuiCheckbox-colorPrimary PrivateSwitchBase-checked-5 Mui-checked MuiIconButton-colorPrimary"
              data-testid="bcp_checkbox"
            >
              <span
                class="MuiIconButton-label"
              >
                <input
                  checked=""
                  class="PrivateSwitchBase-input-7"
                  data-indeterminate="false"
                  type="checkbox"
                  value=""
                />
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root"
                  focusable="false"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                  />
                </svg>
              </span>
              <span
                class="MuiTouchRipple-root"
              />
            </span>
            <span
              class="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1"
            >
              <div
                class="MuiBox-root MuiBox-root-8"
              >
                <span
                  class="MuiTypography-root MuiTypography-body2"
                >
                  I’m enrolled in the Business Cost Premium / Longitudinal Family Physician
                </span>
              </div>
            </span>
          </label>
          <div
            class="MuiBox-root MuiBox-root-9"
          >
            <span
              class="MuiTypography-root MuiTypography-body1"
            >
              Enrolment in the Business Cost Premium / Longitudinal Family Physician will allow you to create a private facility for your office and include it in every claim. If not enrolled, you'll only be asked for a publicly listed facility if the claim requires it.
               
              <a
                class="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary"
                href="https://support.dr-bill.ca/en/articles/5274972-business-cost-premium-bcp"
                rel="noopener noreferrer"
                target="_blank"
              >
                Learn more about BCP.
              </a>
               / 
              <a
                class="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary"
                href="https://support.dr-bill.ca/en/articles/6949317-longitudinal-family-physician-lfp-payment-model-enrollment-billing-structure"
                rel="noopener noreferrer"
                target="_blank"
              >
                Learn more about LFP.
              </a>
            </span>
          </div>
        </div>
        <div
          class="MuiGrid-root MuiGrid-container"
        >
          
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <div
              class="MuiBox-root MuiBox-root-10"
            >
              <div
                class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-space-between"
              >
                <div
                  class="MuiBox-root MuiBox-root-11"
                >
                  <span
                    class="MuiTypography-root MuiTypography-body2"
                  >
                    My Facility
                  </span>
                </div>
                <div
                  class="MuiBox-root MuiBox-root-12"
                  style="cursor: pointer;"
                >
                  <svg
                    aria-hidden="true"
                    class="MuiSvgIcon-root"
                    focusable="false"
                    style="color: rgb(16, 128, 128);"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                    />
                  </svg>
                  <div
                    class="MuiBox-root MuiBox-root-13"
                  >
                    <span
                      class="MuiTypography-root MuiTypography-body2"
                    >
                      Add New
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="MuiBox-root MuiBox-root-14"
              >
                <span
                  class="MuiTypography-root MuiTypography-body1"
                >
                  Create a facility for every office that’s registered with MSP for BCP / LFP. You’ll be able to select these facilities in a claim and also set a facility as your default facility.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthMd"
    >
      <div
        class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
      >
        <div
          class="MuiSnackbar-root MuiSnackbar-anchorOriginTopCenter"
        >
          <div
            class="MuiPaper-root MuiAlert-root MuiAlert-filledError makeStyles-root-1 MuiPaper-elevation0"
            direction="down"
            role="alert"
            style="opacity: 1; transform: scale(1, 1); transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;"
          >
            <div
              class="MuiAlert-icon"
            >
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <path
                  d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                />
              </svg>
            </div>
            <div
              class="MuiAlert-message"
            />
            <div
              class="MuiAlert-action"
            >
              <button
                aria-label="Close"
                class="MuiButtonBase-root MuiIconButton-root MuiIconButton-colorInherit MuiIconButton-sizeSmall"
                tabindex="0"
                title="Close"
                type="button"
              >
                <span
                  class="MuiIconButton-label"
                >
                  <svg
                    aria-hidden="true"
                    class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                    focusable="false"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                    />
                  </svg>
                </span>
                <span
                  class="MuiTouchRipple-root"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
      >
        
        <div
          class="MuiBox-root MuiBox-root-3"
        >
          <span
            class="MuiTypography-root MuiTypography-body1"
          >
            Business Cost Premium / Longitudinal Family Physician
          </span>
        </div>
        <label
          class="MuiFormControlLabel-root"
        >
          <span
            aria-disabled="false"
            class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-4 MuiCheckbox-root MuiCheckbox-colorPrimary PrivateSwitchBase-checked-5 Mui-checked MuiIconButton-colorPrimary"
            data-testid="bcp_checkbox"
          >
            <span
              class="MuiIconButton-label"
            >
              <input
                checked=""
                class="PrivateSwitchBase-input-7"
                data-indeterminate="false"
                type="checkbox"
                value=""
              />
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <path
                  d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                />
              </svg>
            </span>
            <span
              class="MuiTouchRipple-root"
            />
          </span>
          <span
            class="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1"
          >
            <div
              class="MuiBox-root MuiBox-root-8"
            >
              <span
                class="MuiTypography-root MuiTypography-body2"
              >
                I’m enrolled in the Business Cost Premium / Longitudinal Family Physician
              </span>
            </div>
          </span>
        </label>
        <div
          class="MuiBox-root MuiBox-root-9"
        >
          <span
            class="MuiTypography-root MuiTypography-body1"
          >
            Enrolment in the Business Cost Premium / Longitudinal Family Physician will allow you to create a private facility for your office and include it in every claim. If not enrolled, you'll only be asked for a publicly listed facility if the claim requires it.
             
            <a
              class="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary"
              href="https://support.dr-bill.ca/en/articles/5274972-business-cost-premium-bcp"
              rel="noopener noreferrer"
              target="_blank"
            >
              Learn more about BCP.
            </a>
             / 
            <a
              class="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary"
              href="https://support.dr-bill.ca/en/articles/6949317-longitudinal-family-physician-lfp-payment-model-enrollment-billing-structure"
              rel="noopener noreferrer"
              target="_blank"
            >
              Learn more about LFP.
            </a>
          </span>
        </div>
      </div>
      <div
        class="MuiGrid-root MuiGrid-container"
      >
        
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <div
            class="MuiBox-root MuiBox-root-10"
          >
            <div
              class="MuiGrid-root MuiGrid-container MuiGrid-justify-xs-space-between"
            >
              <div
                class="MuiBox-root MuiBox-root-11"
              >
                <span
                  class="MuiTypography-root MuiTypography-body2"
                >
                  My Facility
                </span>
              </div>
              <div
                class="MuiBox-root MuiBox-root-12"
                style="cursor: pointer;"
              >
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root"
                  focusable="false"
                  style="color: rgb(16, 128, 128);"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                  />
                </svg>
                <div
                  class="MuiBox-root MuiBox-root-13"
                >
                  <span
                    class="MuiTypography-root MuiTypography-body2"
                  >
                    Add New
                  </span>
                </div>
              </div>
            </div>
            <div
              class="MuiBox-root MuiBox-root-14"
            >
              <span
                class="MuiTypography-root MuiTypography-body1"
              >
                Create a facility for every office that’s registered with MSP for BCP / LFP. You’ll be able to select these facilities in a claim and also set a facility as your default facility.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
